import {
    Settings,
    Car,
    Shield,
    Home,
    Coins,
    RefreshCcw,
} from 'lucide-react';

// Categorias e Subcategorias
export const escalationCategories = [
    {
        id: 'account_adjustments',
        label: 'Ajustes de Conta / ID / Personagem',
        icon: Settings,
        color: 'blue',
        subcategories: [
            'Troca de ID',
            'Correção de ID duplicado',
            'Correção de nome do personagem',
            'Reset de personagem',
            'Vincular Discord novamente',
            'Remover conta antiga vinculada',
            'Troca de servidor vinculada ao mesmo Discord',
            'Recuperar personagem preso no limbo',
            'Corrigir horário de criação da conta',
            'Liberar acesso após erro de autenticação',
            'Outro'
        ]
    },
    {
        id: 'vehicles',
        label: 'Veículos',
        icon: Car,
        color: 'orange',
        subcategories: [
            'Transferência de veículo entre players',
            'Transferência de veículo entre IDs do mesmo player',
            'Recuperar veículo desaparecido',
            'Veículo sumiu da garagem',
            'Corrigir veículo que não aparece no mapa',
            'Ajustar blindagem de veículo',
            'Remover veículo bugado',
            'Reembolsar veículo comprado errado',
            'Corrigir cor / tuning não registrado',
            'Ativar veículo exclusivo após compra',
            'Outro'
        ]
    },
    {
        id: 'vip_benefits',
        label: 'VIP / Benefícios',
        icon: Shield,
        color: 'purple',
        subcategories: [
            'Adicionar VIP manualmente',
            'Remover VIP manualmente',
            'VIP não caiu após pagamento',
            'Trocar plano VIP',
            'Transferir VIP para outro ID',
            'Renovação manual do VIP',
            'Remover VIP duplicado',
            'Corrigir salário VIP não recebido',
            'Corrigir itens VIP que não chegaram',
            'Reembolso de VIP aplicado no servidor errado',
            'Outro'
        ]
    },
    {
        id: 'properties',
        label: 'Residências / Propriedades',
        icon: Home,
        color: 'green',
        subcategories: [
            'Transferência de casa para outro ID',
            'Remover casa vencida',
            'Baú da casa não funciona',
            'Corrigir garagem da residência',
            'Corregir endereço aplicado errado',
            'Devolver coins por compra de casa duplicada',
            'Remover residência abandonada',
            'Casa travada sem acesso',
            'Resetar interior bugado',
            'Corrigir chave de casa não funcionando',
            'Outro'
        ]
    },
    {
        id: 'economy',
        label: 'Economia / Coins / Compras',
        icon: Coins,
        color: 'yellow',
        subcategories: [
            'Coins não recebidos (compra aprovada)',
            'Compra enviada para ID errado',
            'Erro ao comprar pack ou traje',
            'Remover item comprado por engano',
            'Ajustar saldo do banco após bug',
            'Devolver dinheiro perdido por crash',
            'Falha ao entregar coins por PayPal/Pix',
            'Corrigir compra de pet/painel/bunker',
            'Outro'
        ]
    },
    {
        id: 'refunds',
        label: 'Reembolso',
        icon: RefreshCcw,
        color: 'red',
        subcategories: [
            'Reembolso por compra duplicada',
            'Reverter transação indevida',
            'Problemas com compras',
            'Reembolsos',
            'Verificações'
        ]
    }
];

// Cargos que podem ter acesso
export const availableRoles = [
    { value: 'suporte', label: 'Suporte' },
    { value: 'suporte_compras', label: 'Suporte Compras' },
    { value: 'suporte_descontos', label: 'Suporte Descontos' },
    { value: 'moderador', label: 'Moderador' },
    { value: 'super_moderador', label: 'Super Moderador' },
    { value: 'analista_qualidade', label: 'Analista de Qualidade' },
    { value: 'head_suporte', label: 'Head Suporte' },
    { value: 'head_moderacao', label: 'Head Moderação' },
    { value: 'head_staff', label: 'Head Staff' },
    { value: 'departamento_juridico', label: 'Departamento Jurídico' },
    { value: 'direcao', label: 'Direção' },
    { value: 'admin', label: 'Administrador' },
    { value: 'programador', label: 'Programador' }
];
